import { h } from '../utils'

interface FieldLabelOptions {
  text: string
  id: string
  required?: boolean
}

export function fieldLabel(options: FieldLabelOptions) {
  return h(
    'label',
    { class: 'vbzc-field-label' + (options.required ? ' vbzc-field-label-required' : ''), for: options.id },
    { text: options.text },
  ) as HTMLLabelElement
}
